import { GridCol, mixins, styled } from '@bob/library'

export const StyledCol = styled(GridCol)`
  ${mixins.margin.bottom(30)}

  a {
    display: block;
    height: 100%;
  }
`
export const Header = styled.h3`
  display: flex;
  align-items: center;
  ${mixins.typography.headlineSmall}
  ${mixins.margin(0, 0, 15)};

  & svg {
    flex-shrink: 0;
    ${mixins.margin.right(5)};
  }
`

export const Description = styled.div`
  width: 100%;
  ${mixins.margin(25, 0)};

  & p {
    ${mixins.typography.paragraphMedium}
    font-weight: 400;
    color: ${mixins.colors.grayDark};
    ${mixins.margin(0)};
  }
`
export const NavItem = styled.div`
  height: 100%;
  ${mixins.padding(30)};
  border-radius: 15px;
  ${mixins.shadows.flatNear}
`
